import {htmlLoading} from "./global";
$(document).ready(function () {
    $('.list-block-title').click(function() {
        $(this).closest('.list-block-content').toggleClass('open');
        if (!$(this).hasClass('open')) {
            $('.recipes-import-update-msg-box').addClass('hidden');
            $('.recipe-db-write-msg-box').addClass('hidden');
        }
    });
    $('.role-perm-group').on('full-access partial-access no-access', function(e) {
        var $this = $(this),
            form = $this.closest('form'),
            onoff_switch = $this.find('.role-perm-group-title :checkbox'),
            onoff_switch_group = onoff_switch.closest('.onoffswitch-checkbox'),
            label = onoff_switch_group.find('> label');

        if (e.type == 'no-access') {
            onoff_switch.prop('checked', false);
            onoff_switch_group.removeClass('partly-checked');
            label.text(form.attr('data-onoff-switch-no'));
        }
        else if (e.type == 'partial-access') {
            onoff_switch.prop('checked', true);
            onoff_switch_group.addClass('partly-checked');
            label.text(form.attr('data-onoff-switch-partial'));
        }
        else if (e.type == 'full-access') {
            onoff_switch.prop('checked', true);
            onoff_switch_group.removeClass('partly-checked');
            label.text(form.attr('data-onoff-switch-full'));
        }
    });

    $('.role-perm-group-title :checkbox').change(function() {
        var $this = $(this),
            checked = $this.is(':checked'),
            group = $this.closest('.role-perm-group');
        group.find('.perm :checkbox').prop('checked', checked);
        group.trigger(checked ? 'full-access' : 'no-access');
    });
    $('.role-perm-group .perm :checkbox').on('change check', function() {
        var group = $(this).closest('.role-perm-group'),
            checkboxes = group.find('.perm :checkbox'),
            checked = checkboxes.filter(':checked'),
            onoff_switch = group.find('.role-perm-group-title :checkbox'),
            onoff_switch_group = onoff_switch.closest('.onoffswitch-checkbox');

        // none checked?
        if (!checked.length) {
            group.trigger('no-access');

        // not all checked
        } else if (checked.length != checkboxes.length) {
            group.trigger('partial-access');

        // all checked
        } else if (checked.length == checkboxes.length) {
            group.trigger('full-access');
        }
    });
    // on load check switches
    $('.role-perm-group').each(function() {
        $(this).find('.perm:first :checkbox').trigger('check');
    });
    // role selector
    // role selector
    $('#users-role-select [type=radio]').on('change', function() {
        var $this = $(this);

        if (!$this.is('[data-url]')) {
            $('.role-perm-group [type=checkbox]').prop('checked', false);
            $('.role-perm-group').each(function() {
                $(this).find('.perm:first :checkbox').trigger('check');
            });
            return;
        }
        $.ajax({
            url: $this.attr('data-url'),
            beforeSend: function() {
                htmlLoading();
            },
            success: function(data) {
                if (data) {
                    $('.perm [type=checkbox]').prop('checked', false);
                }

                $.each(data, function(group, perms) {
                    $.each(perms, function(key, perm) {
                        var id = '#perm_'+group+'_'+perm;
                        $(id).prop('checked', true);
                    });
                });
                $('.role-perm-group').each(function() {
                    $(this).find('.perm:first :checkbox').trigger('check');
                });

                $('.recommended-perm-text').removeClass('hidden');
                $('#perm_recipes_import, #perm_recipes_read_comments').each(function() {
                    var obj_tmp = $(this).parents('.perm-label-and-checkbox-group').find('.recommended-perm-text');
                    if (!$(this).prop('checked')) {
                        if (!$('#perm_recipes_import_update').prop('checked')) {
                            obj_tmp.addClass('hidden');
                        }
                    } else {
                        obj_tmp.addClass('hidden');
                    }
                });

                var obj_tmp = $("#perm_recipe_db_read_comments").parents('.perm-label-and-checkbox-group').find('.recommended-perm-text');
                if (!$(this).prop('checked')) {
                    if (!$('#perm_recipe_db_write').prop('checked')) {
                        obj_tmp.addClass('hidden');
                    }
                } else {
                    obj_tmp.addClass('hidden');
                }

                var obj_tmp = $("#perm_erp_orders").parents('.perm-label-and-checkbox-group').find('.recommended-perm-text');
                if (!$(this).prop('checked')) {
                    if (!$('#perm_erp_confirm_cancel_order').prop('checked') && !$('#perm_erp_uncancel_order').prop('checked')) {
                        obj_tmp.addClass('hidden');
                    }
                } else {
                    obj_tmp.addClass('hidden');
                }
            }
        })
    });

    function generateInputTags() {
        $('.suggestions-div').empty();
        if ($('input[name="filter_subusers"]').length > 0) {
            var counter = 0;
            if (counter <= 5) {
                $('.location-li').each(function () {
                    if ($(this).find('input').prop('checked')) {
                        if (counter <= 5) {
                            counter++;
                            $('.suggestions-div').append('<div class="suggestion" data-type="location" data-value="' + $(this).find('input').val() + '"><span class="long-name">' + $(this).find('.checkmark-label').html() + '</span><span class="left-x">x</div>');
                        } else {
                            return false;
                        }
                    }
                });
            }
            if (counter <= 5) {
                $('.role-li').each(function () {
                    if ($(this).find('input').prop('checked')) {
                        if (counter <= 5) {
                            counter++;
                            $('.suggestions-div').append('<div class="suggestion" data-type="role" data-value="' + $(this).find('input').val() + '"><span class="long-name">' + $(this).find('.checkmark-label').html() + '</span><span class="left-x">x</div>');
                        } else {
                            return false;
                        }
                    }
                });
            }
            if (counter <= 5) {
                if ($('input[name="filter_subusers"]').val().trim() != "") {
                    counter++;
                    $('.suggestions-div').append('<div class="suggestion" data-type="search_subusers"><span class="long-name">' + $('input[name="filter_subusers"]').val() + '</span><span class="left-x">x</div>');
                }
            }
            if (counter > 5) {
                $('.suggestions-div').empty();
                $('.suggestions-div').append('<div class="suggestion" data-type="too_many_filters"><span class="long-name">' + $('.too-many-filters-txt').html() + '</span><span class="left-x">x</div>');
            } else {
                if (counter > 1) {
                    $('.suggestions-div').append('<div class="clear-all">' + $('.clear-all-txt').html() + '</div>');
                }
            }
        } else if ($('input[name="filter_roles"]').length > 0) {
            if ($('input[name="filter_roles"]').val().trim() != "") {
                $('.suggestions-div').append('<div class="suggestion" data-type="search_roles"><span class="long-name">' + $('input[name="filter_roles"]').val() + '</span><span class="left-x">x</div>');
            }
        }
    }

    function recommendedPermAction(e) {
        var obj_tmp = $('#' + e + '');
        var arr_tmp = ["perm_recipes_import", "perm_recipes_read_comments"];

        if (obj_tmp.prop('checked')) {
            obj_tmp.parents('.perm-label-and-checkbox-group').find('.recommended-perm-text').addClass('hidden');
        } else {
            if ((arr_tmp.includes(e) && $('#perm_recipes_import_update').prop('checked')) || (e == "perm_recipe_db_read_comments" && $('#perm_recipe_db_write').prop('checked')) || (e == "perm_erp_orders" && ($('#perm_erp_confirm_cancel_order').prop('checked') || $('#perm_erp_uncancel_order').prop('checked'))))  {
                obj_tmp.parents('.perm-label-and-checkbox-group').find('.recommended-perm-text').removeClass('hidden');
            }
        }
    }

    function recommendedRecipesPermsAction(e) {
        var arr_tmp = ["perm_recipes_import", "perm_recipes_read_comments"];
        if (e == "perm_recipes_import_update") {
            if ($('#' + e).prop('checked')) {
                arr_tmp.forEach(value => recommendedPermAction(value));
            } else {
                $('#' + e).parents('.role-perm-group').find('.recommended-perm-text').addClass('hidden');
            }
        } else {
            recommendedPermAction(e);
        }
    }

    function recommendedRecipeDatabasePermAction(e) {
        if (e == "perm_recipe_db_write") {
            if ($('#' + e).prop('checked')) {
                recommendedPermAction("perm_recipe_db_read_comments");
            } else {
                $('#' + e).parents('.role-perm-group').find('.recommended-perm-text').addClass('hidden');
            }
        } else {
            recommendedPermAction(e);
        }
    }

    function recommendedErpPermAction(e) {
        console.log('ovdje da da')
        if (e == "perm_erp_confirm_cancel_order" || e == "perm_erp_uncancel_order") {
            if ($('#' + e).prop('checked')) {
                recommendedPermAction("perm_erp_orders");
            } else {
                $('#' + e).parents('.role-perm-group').find('.recommended-perm-text').addClass('hidden');
            }
        } else {
            recommendedPermAction(e);
        }
    }

    $('.perm.list-item').on('change', function() {
        var arr1 = ["perm_recipes_import_update", "perm_recipes_import", "perm_recipes_read_comments"];
        var arr2 = ["perm_recipe_db_write", "perm_recipe_db_read_comments"];
        var arr3 = ["perm_erp_confirm_cancel_order", "perm_erp_uncancel_order", "perm_erp_orders"];
        var selected_perm = $(this).find('input').attr('id');
        if (arr1.includes(selected_perm)) {
            recommendedRecipesPermsAction(selected_perm);
        } else if (arr2.includes(selected_perm)) {
            recommendedRecipeDatabasePermAction(selected_perm);
        } else if (arr3.includes(selected_perm)) {
            recommendedErpPermAction(selected_perm);
        } 
    });

    $('.onoffswitch-checkbox').on('change', function() {
        $(this).parents('.role-perm-group').find('.recommended-perm-text').addClass('hidden');
    });

    function countClickedListItems(obj) {
        var counter = 0;
        obj.parents('.dropdown-filter-ul').children('.filter-row').each(function() {
            if ($(this).find('input').prop('checked')) {
                counter++;
            }
        });
        return counter;
    }

    function updateDropdownBtnMessage(obj) {
        var ul_obj = obj.parents('.dropdown-filter-ul');
        var locations = obj.hasClass('all-locations-li') || obj.hasClass('location-li');
        var counter = countClickedListItems(obj);
        if (counter == ul_obj.find('.filter-row').length) {
            if (locations) {
                $('.all-locations-li').find('input').prop('checked', true);
                ul_obj.parent().find('.dropdown-btn-style').html('<span class="long-name">' + $('.all-locations-selection-template-text').html() + " </span><span class=\"caret\"></span>");
            } else {
                $('.all-roles-li').find('input').prop('checked', true);
                ul_obj.parent().find('.dropdown-btn-style').html('<span class="long-name">' + $('.all-roles-selection-template-text').html() + " <span class=\"caret\"></span>");
            }
        } else {
            if (locations) {
                $('.all-locations-li').find('input').prop('checked', false);
                ul_obj.parent().find('.dropdown-btn-style').html('<span class="long-name">' + $('.locations-selection-template-text').html() + "(" + counter + ")</span> <span class=\"caret\"></span>");
            } else {
                $('.all-roles-li').find('input').prop('checked', false);
                ul_obj.parent().find('.dropdown-btn-style').html('<span class="long-name">' + $('.roles-selection-template-text').html() + "(" + counter + ")</span> <span class=\"caret\"></span>");
            }
        }
    }

    $('.all-locations-li, .all-roles-li').on('click', function(e) {
        e.stopPropagation();
        if ($(this).find('input').prop('checked')) {
            if ($(this).hasClass('all-locations-li')) {
                $(this).parents('.dropdown-filter-ul').find('.location-li input').prop('checked', true);
            } else {
                $(this).parents('.dropdown-filter-ul').find('.role-li input').prop('checked', true);
            }
        } else {
            if ($(this).hasClass('all-locations-li')) {
                $(this).parents('.dropdown-filter-ul').find('.location-li input').prop('checked', false);
            } else {
                $(this).parents('.dropdown-filter-ul').find('.role-li input').prop('checked', false);
            }
        }
        updateDropdownBtnMessage($(this));
    });

    $('.location-li, .role-li').on('click', function(e) {
        e.stopPropagation();
        updateDropdownBtnMessage($(this));
    });

    $('.filter-btn-li, .find-btn').on('click', function() {
        if ($(this).hasClass('filter-roles-btn')) {
            var role = $('input[name="filter_roles"]').val().trim();
            $.ajax({
                url: '/users/roles/filter_roles',
                type: 'post',
                data: {
                    role: role
                },
                beforeSend: function() {
                    htmlLoading();
                },
                success: function(data) {
                    var obj = $('.subusers-table');
                    if (data['empty_roles_search']) {
                        obj.find('thead').addClass('hidden');
                        obj.find('tbody').empty();
                        obj.find('tbody').append(data['empty_html']);
                    } else {
                        obj.find('thead').removeClass('hidden');
                        obj.find('tbody').remove();
                        obj.append(data['html']);
                    }
                    generateInputTags();
                    htmlLoading(false);
                }
            });
        } else {
            var rest_ids = [], role_ids = [], string = $('input[name="filter_subusers"]').val().trim();
            $('input[name="rest_ids[]"]').each(function() {
                if ($(this).prop('checked')) {
                    rest_ids.push($(this).val());
                }
            });
            $('input[name="role_ids[]"]').each(function() {
                if ($(this).prop('checked')) {
                    role_ids.push($(this).val());
                }
            });
            $.ajax({
                url: '/users/filter_subusers',
                type: 'post',
                data: {
                    rest_ids: rest_ids,
                    role_ids: role_ids,
                    string: string
                },
                beforeSend: function() {
                    htmlLoading();
                },
                success: function(data) {
                    var obj = $('.subusers-table');
                    if (data['empty_subusers_search']) {
                        obj.find('thead').addClass('hidden');
                        obj.find('tbody').empty();
                        obj.find('tbody').append(data['empty_html']);
                    } else {
                        obj.find('thead').removeClass('hidden');
                        obj.find('tbody').remove();
                        obj.append(data['html']);
                    }
                    generateInputTags();
                    htmlLoading(false);
                }
            });
        }
    });

    $('input[name="filter_subusers"], input[name="filter_roles"]').keydown(function(e) {
        if (e.which == 13) {
            $(this).parents('.input-search-div').find('.find-btn').trigger('click');
            generateInputTags();
        }
    });

    $('body').on('click', '.suggestion', function() {
        var data_type = $(this).attr('data-type');
        var data_value = $(this).attr('data-value');
        if (data_type == "location") {
            $('.location-li').each(function() {
                if ($(this).find('input').val() == data_value) {
                    $(this).find('input').prop('checked', false);
                    updateDropdownBtnMessage($(this));
                    return false;
                }
            });
        } else if (data_type == "role") {
            $('.role-li').each(function() {
                if ($(this).find('input').val() == data_value) {
                    $(this).find('input').prop('checked', false);
                    updateDropdownBtnMessage($(this));
                    return false;
                }
            });
        } else if (data_type == "search_subusers") {
            $('input[name="filter_subusers"]').val("");
        } else if (data_type == "search_roles") {
            $('input[name="filter_roles"]').val("");
        } else if (data_type == "too_many_filters") {
            if ($('input[name="filter_subusers"]').length > 0) {
                $('input[name="filter_subusers"]').val("");
                $('.all-locations-li, .location-li, .all-roles-li, .role-li').find('input').prop('checked', false);
                updateDropdownBtnMessage($('.all-locations-li'));
                updateDropdownBtnMessage($('.all-roles-li'));
            } else {
                $('input[name="filter_roles"]').val("");
            }
        }
        $(this).remove();
        if ($('.suggestions-div').lenght <= 1) {
            $('.suggestions-div').find('.clear-all').remove();
        }
        $('.find-btn').trigger('click');
    });

    $('body').on('click', '.clear-all', function() {
        $('input[name="filter_subusers"]').val("");
        $('.all-locations-li, .location-li, .all-roles-li, .role-li').find('input').prop('checked', false);
        updateDropdownBtnMessage($('.all-locations-li'));
        updateDropdownBtnMessage($('.all-roles-li'));
        $('.suggestions-div').empty();
        $('.find-btn').trigger('click');
    });
});